    import React, { useState } from 'react';


    import { Select, DatePicker, Form, Button, Card, message, Input } from 'antd';
    import { CalendarOutlined, SearchOutlined } from '@ant-design/icons';

    const { Option } = Select;

    const MonthSelectionForm = ({ onSubmit, initialValues = {}, loading = false }) => {
    const [form] = Form.useForm();
    const months = [
        'January', 'February', 'March', 'April',
        'May', 'June', 'July', 'August',
        'September', 'October', 'November', 'December'
    ];

    const onCalendarChange = (date, dateString) => {
        form.setFieldsValue({ calendarMonth: dateString });
    };

    const handleReset = () => {
        form.resetFields();
    };

    return (
        <Form
        className='flex self-end '
        form={form}
        layout="vertical"
        onFinish={onSubmit}
        initialValues={initialValues}
        >




      <Form.Item
        // label="Search"
        name="search"

      >
        <Input
        
          placeholder="Search"
          prefix={<SearchOutlined />}
        />
      </Form.Item>

            <Form.Item
            className='ml-3'
            name="calendarMonth"
            // label="Select Month"
            rules={[{ required: true, message: 'Please select a month' }]}
            >
            <DatePicker.MonthPicker
                style={{ width: '100%' }}
                placeholder="Month"
                onChange={onCalendarChange}
                suffixIcon={<CalendarOutlined />}
                format="MMMM YYYY"
            />
            </Form.Item>

            {/* <Form.Item>
            <Button 
                type="primary" 
                htmlType="submit" 
                loading={loading}
                style={{ marginRight: 8 }}
            >
                Submit
            </Button>
            <Button htmlType="button" onClick={handleReset}>
                Reset
            </Button>
            </Form.Item> */}

        </Form>
    );
    };

    // Parent Component Implementation

    export default MonthSelectionForm;